import formatAndCapitalize from "@/providers/formatAndCapitalize";

export default class SelectOption {
  constructor(value, id) {
    this.id = id || value.replaceAll(" ", "-").toLocaleLowerCase()
    this.value = formatAndCapitalize(value);
  }
}